import { fromJS } from 'immutable';

export default class Payload {
  constructor({ type, entity = {}, config = {} }) {
    return fromJS({ type, entity, config });
  }
}



// WEBPACK FOOTER //
// ./src/app/utils/Payload/Payload.js